<template>
  <div class="overflow-x-auto scrollbar-hidden">
    <div
      id="tabulator"
      ref="tableRef"
      class="mt-5 table-report table-report--tabulator"
    ></div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { TabulatorFull as Tabulator } from 'tabulator-tables'
import langs from '@/locale.tabulator'
import roleApi from '@/services/security/role.api'

export default defineComponent({
  data() {
    return {
      tabulator: null
    }
  },
  methods: {
    showDetail(e, cell) {
      if (cell.getData().role === 'PROVIDER_MANAGER') {
        this.$store.dispatch(
          'auth/setRole',
          {
            provider: cell.getData().providerUUID,
            branch: null,
            employee: null
          }
        )
        this.$router.push({ name: 'side-menu-home' })
      }
      if (cell.getData().role === 'PROVIDER_EMPLOYEE') {
        this.$store.dispatch(
          'auth/setRole',
          {
            provider: cell.getData().providerUUID,
            branch: null,
            employee: cell.getData().employeeUUID
          }
        )
        this.$router.push({ name: 'admin-employees-home' })
      }
    },
    detailFormatter(cell) {
      return (
        '<div class="flex lg:justify-center items-center"><button class="btn btn-primary detail-action">' +
        this.$t('public.loginIn') +
        '</button></div>'
      )
    },
    formatRole(cell) {
      return (
        '<div><div class="font-medium whitespace-nowrap">' +
        this.$t('admin.role.type.' + cell.getData().role) +
        '</div></div>'
      )
    }
  },
  mounted() {
    this.tabulator = new Tabulator(this.$refs.tableRef, {
      locale: 'sk',
      langs: langs,
      ajaxURL: '#',
      ajaxConfig: 'POST',
      ajaxRequestFunc: function(url, config, params) {
        return roleApi.getList(params.page, params.size)
      },
      ajaxResponse: function(url, params, response) {
        const pagination = response.data.pagination
        return {
          data: response.data.data,
          last_page: Math.ceil(pagination.filtered / pagination.perPage)
        }
      },
      printAsHtml: true,
      printStyled: true,
      pagination: true,
      paginationMode: 'remote',
      paginationSize: 10,
      paginationSizeSelector: [10, 20, 30, 40],
      sortMode: 'remote',
      layout: 'fitColumns',
      responsiveLayout: 'collapse',
      placeholder: 'No matching records found',
      columns: [
        {
          formatter: 'responsiveCollapse',
          width: 40,
          minWidth: 30,
          hozAlign: 'center',
          resizable: false,
          headerSort: false
        },

        // For HTML table
        {
          title: this.$t('common.name'),
          minWidth: 200,
          responsive: 0,
          headerSort: false,
          field: 'name',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter(cell) {
            return `<div>
                  <div class="font-medium whitespace-nowrap">${
                    cell.getData().name
                  }</div>
                </div>`
          }
        },
        {
          title: this.$t('admin.role.item'),
          minWidth: 200,
          responsive: 0,
          headerSort: false,
          field: 'role',
          headerHozAlign: 'left',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter: this.formatRole
        },
        {
          title: '',
          maxWidth: 150,
          field: 'actionDetail',
          responsive: 1,
          headerSort: false,
          hozAlign: 'center',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter: this.detailFormatter,
          cellClick: this.showDetail
        }
      ]
    })
  }
})
</script>
